<ng-container *ngIf="shouldShowMenu">
  <med-popover-trigger [menu]="appsMenu">
      <med-button size="small" button-type="icon" color="primary">
        <i class="material-icons">apps</i>
      </med-button>
  </med-popover-trigger>
  <med-menu #appsMenu>
    <med-menu-item *ngIf="hasCtmsAccess" (click)="onCtmsSelect()">CTMS & eTMF</med-menu-item>
  </med-menu>
</ng-container>
